import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import Image from "theme/components/atoms/Image";
import Icon from "theme/components/atoms/Icon";
import AutocompleteItem from "theme/components/organisms/Autocomplete/AutocompleteItem/AutocompleteItem";

const CategoryLabel = ({ paths, result }) => {
  const remaining = paths.slice(-3);
  return (
    <span className="category-result">
      {paths.length > 3 && "..."}
      {remaining.map((path, index) => (
        <span key={index}>
          {index > 0 && <Icon size="mini" icon="chevron-right" title="" />}
          <Link to={result.path} clickType="block">
            {path.name}
          </Link>
        </span>
      ))}
    </span>
  );
};

const CategoriesResultItem = ({ result }) => {
  return (
    <AutocompleteItem
      image={
        result.image && (
          <Image
            src={result.image}
            alt={result.name}
            format="thumbnail"
            appearance="full"
          />
        )
      }
      name={<CategoryLabel paths={result.breadcrumb} result={result} />}
    />
  );
};

export default CategoriesResultItem;
